import { inject, Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import {
  EntityAction,
  EntityCacheAction,
  ofEntityOp,
  OP_ERROR,
  OP_SUCCESS,
} from '@ngrx/data';
import { filter } from 'rxjs/operators';
import { ToastService } from './toast.service';

@Injectable({ providedIn: 'root' })
export class NgrxDataToastService {
  private actions$ = inject(Actions);
  private toast = inject(ToastService);
  constructor() {
    this.actions$
      .pipe(
        ofEntityOp() as any,
        filter(
          (ea: EntityAction) =>
            ea.payload.entityOp.endsWith(OP_SUCCESS) ||
            ea.payload.entityOp.endsWith(OP_ERROR),
        ),
      )
      // this service never dies so no need to unsubscribe
      .subscribe((action) =>
        this.toast.openSnackBar(
          `${action.payload.entityName} action`,
          action.payload.entityOp,
          action,
        ),
      );

    this.actions$
      .pipe(
        ofType(
          EntityCacheAction.SAVE_ENTITIES_SUCCESS,
          EntityCacheAction.SAVE_ENTITIES_ERROR,
        ),
      )
      .subscribe((action: any) =>
        this.toast.openSnackBar(
          `${action.type} - url: ${action.payload.url}`,
          'SaveEntities',
        ),
      );
  }
}
